import React from 'react'
import { AccordionSummary, Box, AccordionSummaryProps } from '@mui/material'

type HeadingLevel = 2 | 3 | 4 | 5 | 6

export interface AccordionHeadingProps extends AccordionSummaryProps {
  level: HeadingLevel
}

/**
 * Wraps AccordionSummary in a semantic heading per the W3C accordion pattern:
 * <h2><button>...</button></h2>
 *
 * Pass id and aria-controls here so MUI Accordion can link the summary to its panel.
 */
export const AccordionHeading = ({
  level,
  id,
  'aria-controls': ariaControls,
  children,
  expandIcon,
  ...summaryProps
}: AccordionHeadingProps) => (
  <Box
    component={`h${level}`}
    sx={{ m: 0, p: 0, fontWeight: 'inherit', fontSize: 'inherit' }}
  >
    <AccordionSummary
      id={id}
      aria-controls={ariaControls}
      expandIcon={expandIcon}
      {...summaryProps}
    >
      {children}
    </AccordionSummary>
  </Box>
)

export default AccordionHeading
